<template>
  <v-dialog v-model="dialog" width="800px" persistent>
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-row dense class="mx-5">
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="materialKeyword"
              @text="KeyWord = $event"
              :label="
                settings &&
                (settings.material_name_display_type == 2 ||
                  settings.material_name_display_type == 3)
                  ? $t('Material.materialNameAndCodeKeyword')
                  : $t('Material.materialNameKeyword')
              "
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="5">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategory v-model="categorySelected" />
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                text
                class="caption font-weight-bold grey--text"
                color="primary"
                @click.stop="onSearch()"
              >
                <v-icon small class="pe-1">fa-search</v-icon>
                {{ $t("Search.search") }}
              </v-btn>
            </template>
            <span>{{ $t("Search.searchTip") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <div
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("Material.Fields.public_flg") }}
            </div>
            <v-chip-group v-model="publicFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
                >{{ $t("Material.publicFlgs.on") }}</v-chip
              >
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
                >{{ $t("Material.publicFlgs.off") }}</v-chip
              >
            </v-chip-group>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row dense align="center" class="pa-1">
            <div
              class="caption grey--text input-chip-group-label"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ $t("StockMaterials.Fields.usable") }}
            </div>
            <v-chip-group v-model="chooseFlgs" column multiple class="mx-1">
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="primary"
                text-color="white"
                :key="1"
                :value="1"
                >{{ $t("CRUD.choosed") }}</v-chip
              >
              <v-chip
                small
                label
                filter
                class="mx-1"
                color="grey"
                text-color="white"
                :key="0"
                :value="0"
                >{{ $t("CRUD.unchoose") }}</v-chip
              >
            </v-chip-group>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="materialItems"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:item.Description="{ item }">
          <span>
            {{$t(settings
              ? settings.material_name_display_type == 1
                  ? "Material.materialName"
                  : settings.material_name_display_type == 4
                      ? "Material.nameWithCode"
                  : "Material.materialNameWithCode"
              : "Material.materialName", [item.material_code, item.material_name])
            }}
          </span>
          <br />
          <span class="caption secondary--text">
            {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
            <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
              {{ item.standard_name.slice(0, 12) + "......" }}
            </span>
            <span v-else>
              {{ item.standard_name }}
            </span>
          </span>
        </template>
        <template v-slot:item.public_flg="{ item }">
          <v-chip
            small
            label
            :color="item.public_flg ? 'primary' : 'grey'"
            text-color="white"
          >
            {{
              item.public_flg
                ? $t("Material.publicFlgs.on")
                : $t("Material.publicFlgs.off")
            }}
          </v-chip>
        </template>
        <template v-slot:header.action="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-btn
              color="primary"
              dense
              @click="
                $emit('confirm', item);
                dialog = false;
              "
            >
              {{ $t("Shop.Fields.choose") }}
            </v-btn>
          </div>
        </template>
      </v-data-table>
      <v-card-actions>
        <span class="caption"> </span>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          class="elevation-1"
          @click="dialog = false"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Materials from "@/api/materials";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";

export default {
  name: "MaterialsSelectsDialog",

  props: {
    value: Boolean,
    changed: Array,
    materialIds: Array,
    options: Object,
  },

  components: {
    SearcherKeyword,
    SearcherMaterialCategory,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Material.Fields.material_category"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material_category.name",
        },
        {
          text: i18n.t("Material.Fields.material_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("Material.Fields.public_flg"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "public_flg",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "action",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },

    materialItems() {
      //前端搜索
      return this.materials.filter(
        (item) =>
          ((this.publicFlgs.length &&
            this.publicFlgs.find((flg) => flg == item.public_flg) !=
              undefined) ||
            !this.publicFlgs.length) &&
          ((this.chooseFlgs.length &&
            (item.choose
              ? this.chooseFlgs.find((flg) => flg == item.choose) !=
                  undefined || !item.disabled
              : this.chooseFlgs.find((flg) => flg == item.choose) !=
                undefined)) ||
            !this.chooseFlgs.length) &&
          ((this.categorySelected &&
            item.material_category.code.indexOf(this.categorySelected.code) >
              -1) ||
            !this.categorySelected) &&
          ((this.materialKeyword &&
            item.Description.indexOf(this.materialKeyword) > -1) ||
            !this.materialKeyword)
      );
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    materials: [],
    materialKeyword: "",
    categorySelected: null,
    chooseFlgs: [0],
    publicFlgs: [1],
    itemsPerPageOptions: 10,
    materialIdsChoosed: [],
    fetchTimestamp: 0, //第一次获取商品列表的时间
  }),

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },
    onSearch() {
      this.materialKeyword = this.KeyWord;
    },
    //获取material列表
    getMaterialsFromAPI() {
      if (new Date().getTime() - this.fetchTimestamp < 30 * 60 * 1000) {
        this.materials = this.materials.map((material) => {
          material.Description = i18n.t(
            this.settings
              ? this.settings.material_name_display_type == 4
                ? "Material.nameWithCodeAndStandard"
                : this.settings.material_name_display_type == 3
                ? "Material.materialNameWithCodeAndStandard"
                : this.settings.material_name_display_type == 2
                ? "Material.materialNameWithCode"
                : "Material.materialName"
              : "Material.materialName",
            [
              material.material_code,
              material.material_name,
              material.standard_name,
            ]
          );

          if (
            this.materialIdsChoosed.indexOf(material.id) > -1 &&
            (!material.choose || !material.disabled)
          ) {
            material = Object.assign({}, material, {
              choose: 1,
              disabled: true,
            });
          } else if (
            this.materialIdsChoosed.indexOf(material.id) == -1 &&
            (material.choose == 1 || material.disabled)
          ) {
            if (material.choose == 1) {
              material.choose = 0;
            }
            if (material.disabled) {
              material.disabled = false;
            }
          }

          return material;
        });

        return;
      }

      let options = this.options;
      var fieldFilter = [
        "id",
        "material_code",
        "material_name",
        "Standard.name",
        "category_code",
        "MaterialCategory.name",
        "MaterialCategory.code",
        "public_flg",
      ];
      options = Object.assign(
        {
          fieldFilter: fieldFilter,
          // 仅筛选少许必要字段
        },
        this.options
      );
      Materials.fetchAllNoPaging(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = response.data.materials.map((material) => {
              material.Description = i18n.t(
                this.settings
                  ? this.settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                [
                  material.material_code,
                  material.material_name,
                  material.standard_name,
                ]
              );
              //默认勾选
              if (this.materialIdsChoosed.indexOf(material.id) > -1) {
                material = Object.assign({}, material, {
                  choose: 1,
                  disabled: true,
                });
              } else {
                if (material.choose == 1 || !material.choose) {
                  material.choose = 0;
                }
                if (material.disabled) {
                  material.disabled = false;
                }
              }

              return material;
            });

            this.fetchTimestamp = new Date().getTime();
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = this.value;
          // console.log(this.materialIds);
          if (this.materialIds && this.materialIds.length) {
            this.materialIdsChoosed = JSON.parse(
              JSON.stringify(this.materialIds)
            );
          }
          this.getMaterialsFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.materialKeyword = "";
          this.categorySelected = null;
          this.chooseFlgs = [0];
          this.publicFlgs = [1];
        }
        this.$emit("input", this.dialog);
      },
    },
    materials: {
      deep: true,
      handler() {},
    },
  },
};
</script>